import { FC } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';

import generatePicker, {
  PickerDateProps,
} from 'antd/lib/date-picker/generatePicker';

import styles from './datePickerInput.module.less';

interface DatePickerLocalProps {
  placeholder?: string;
}

type Props = DatePickerLocalProps & PickerDateProps<Dayjs>;

// Without this, dayjs(text, format, true) silently ignores the format/strict
// args and falls back to native Date parsing.
dayjs.extend(customParseFormat);

// rc-picker parses typed text without strict mode, so 13/45/2027 overflows
// into 02/14/2028 and is committed as if the user had typed that date.
const strictDayjsGenerateConfig: typeof dayjsGenerateConfig = {
  ...dayjsGenerateConfig,
  locale: {
    ...dayjsGenerateConfig.locale,
    parse: (_locale, text, formats) =>
      formats
        .map((format) => dayjs(text, format, true))
        .find((parsed) => parsed.isValid()) ?? null,
  },
};

const DatePicker = generatePicker<Dayjs>(strictDayjsGenerateConfig);

const DatePickerInput: FC<Props> = (props: Props) => {
  const { suffixIcon, ...rest } = props;
  return (
    <div className={styles.datePickerWrapper}>
      <DatePicker {...rest} suffixIcon={suffixIcon} />
    </div>
  );
};

export default DatePickerInput;
